<template>
  <div class="aiw2-setup">
    <hero title="Set up your article" :keyword="keyword" :mode="mode" :page-run="pageRun"
      info-title="Everything on this page tells POP what to write: your keyword, your audience, your length and tone. Get it right here and the draft comes back much closer to what you want. These settings lock once you continue." />

    <content-source-section
      :model="setup"
      :fetching="fetching"
      :fetch-error="fetchError"
      @change="onChange"
      @fetch="(url) => $emit('fetch', url)"
    />

    <required-setup-section
      :model="setup"
      :current-word-count="currentWordCount"
      :target-word-count="targetWordCount"
      @change="onChange"
    />

    <quality-settings-section :model="setup" @change="onChange" />

    <advanced-section :model="setup" @change="onChange" />
  </div>
</template>

<script>
import Hero from "../../components/Hero.vue";
import ContentSourceSection from "./ContentSourceSection.vue";
import RequiredSetupSection from "./RequiredSetupSection.vue";
import QualitySettingsSection from "./QualitySettingsSection.vue";
import AdvancedSection from "./AdvancedSection.vue";
import { MODES } from "../../constants";

export default {
  name: "AiwV2SetupStep",
  components: { Hero, ContentSourceSection, RequiredSetupSection, QualitySettingsSection, AdvancedSection },
  props: {
    setup: { type: Object, required: true },
    mode: { type: String, default: MODES.GUIDED },
    keyword: { type: String, default: "" },
    pageRun: { type: Object, default: () => ({}) },
    currentWordCount: { type: Number, default: 0 },
    targetWordCount: { type: Number, default: 0 },
    fetching: { type: Boolean, default: false },
    fetchError: { type: String, default: "" },
  },
  methods: {
    onChange() {
      this.$emit("change");
    },
  },
};
</script>

<style scoped>
.aiw2-setup { max-width: 820px; margin: 0 auto; }
</style>
